export enum PageRoute {
  ABOUT = "/about",
  DESIGN = "/design",
  SIGN_IN = "/sign-in",
  SIGN_UP = "/sign-up",
}
